import React, { useState } from 'react';
// import './FloatingNowPlayingBar.scss';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import './CreateNewPlaylist.scss';

export default connect(({}) => {
  return {};
}, actions)(function CreateNewPlaylist(props) {
  const history = useHistory();
  const [name, setName] = useState('');
  const [isAutoRefreshEnabled, setIsAutoRefreshEnabled] = useState(true);

  const createPlaylist = (event) => {
    if (event?.preventDefault) event.preventDefault();
    props.createNewPlaylist(history, name, isAutoRefreshEnabled);
  };

  return (
    <div className="CreateNewPlaylist">
      <form onSubmit={createPlaylist}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 375 667"
        >
          <g clipPath="url(#create-new-playlist-clip0)">
            <path fill="#121212" d="M0 0H375V812H0z"></path>

            <g
              onClick={createPlaylist}
              style={{ pointerEvents: 'bounding-box' }}
            >
              <text
                fill="#fff"
                style={{ whiteSpace: 'pre' }}
                fontSize="13"
                fontWeight="bold"
                letterSpacing="0em"
              >
                <tspan x="317.402" y="76.257">
                  Create
                </tspan>
              </text>
            </g>

            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="141.516" y="77.24">
                New playlist
              </tspan>
            </text>
            <g
              onClick={() => history.goBack()}
              style={{ pointerEvents: 'bounding-box' }}
            >
              <text
                fill="#fff"
                style={{ whiteSpace: 'pre' }}
                fontSize="13"
                letterSpacing="0em"
              >
                <tspan x="16.446" y="76.257">
                  Cancel
                </tspan>
              </text>
            </g>
            <path fill="#333" d="M100 116H276V292H100z"></path>

            <g
              transform="translate(306,440)"
              style={{
                pointerEvents: 'bounding-box',
              }}
              onClick={() => setIsAutoRefreshEnabled(!isAutoRefreshEnabled)}
            >
              {isAutoRefreshEnabled ? (
                <>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.1679 0.0951244C17.942 -0.00810091 19.7141 0.000157109 21.4882 0.000157109C21.5005 0.000157109 30.4781 0.000157109 30.4781 0.000157109C32.2869 0.000157109 34.059 -0.00810091 35.8321 0.0951244C37.4441 0.188027 39.0143 0.38622 40.5773 0.829056C43.8676 1.76015 46.7409 3.70491 48.8178 6.46206C50.8825 9.20166 52 12.5555 52 15.999C52 19.4468 50.8825 22.7985 48.8178 25.5381C46.7409 28.2942 43.8676 30.24 40.5773 31.1711C39.0143 31.6139 37.4441 31.8111 35.8321 31.905C34.059 32.0083 32.2869 31.999 30.5128 31.999C30.5005 31.999 21.5209 32 21.5209 32C19.7141 31.999 17.942 32.0083 16.1679 31.905C14.5569 31.8111 12.9867 31.6139 11.4237 31.1711C8.13341 30.24 5.26016 28.2942 3.18322 25.5381C1.11851 22.7985 0 19.4468 0 16.0001C0 12.5555 1.11851 9.20166 3.18322 6.46206C5.26016 3.70491 8.13341 1.76015 11.4237 0.829056C12.9867 0.38622 14.5569 0.188027 16.1679 0.0951244Z"
                    fill="#1DB954"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36 30C43.732 30 50 23.732 50 16C50 8.26801 43.732 2 36 2C28.268 2 22 8.26801 22 16C22 23.732 28.268 30 36 30Z"
                    fill="white"
                  />
                </>
              ) : (
                <>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.1679 0.0951244C17.942 -0.00810091 19.7141 0.000157109 21.4882 0.000157109C21.5005 0.000157109 30.4781 0.000157109 30.4781 0.000157109C32.2869 0.000157109 34.059 -0.00810091 35.8321 0.0951244C37.4441 0.188027 39.0143 0.38622 40.5773 0.829056C43.8676 1.76015 46.7409 3.70491 48.8178 6.46206C50.8825 9.20166 52 12.5555 52 15.999C52 19.4468 50.8825 22.7985 48.8178 25.5381C46.7409 28.2942 43.8676 30.24 40.5773 31.1711C39.0143 31.6139 37.4441 31.8111 35.8321 31.905C34.059 32.0083 32.2869 31.999 30.5128 31.999C30.5005 31.999 21.5209 32 21.5209 32C19.7141 31.999 17.942 32.0083 16.1679 31.905C14.5569 31.8111 12.9867 31.6139 11.4237 31.1711C8.13341 30.24 5.26016 28.2942 3.18322 25.5381C1.11851 22.7985 0 19.4468 0 16.0001C0 12.5555 1.11851 9.20166 3.18322 6.46206C5.26016 3.70491 8.13341 1.76015 11.4237 0.829056C12.9867 0.38622 14.5569 0.188027 16.1679 0.0951244Z"
                    fill="#282828"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
                    fill="white"
                  />
                </>
              )}
            </g>

            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              letterSpacing="0em"
            >
              <tspan x="16" y="461.24">
                Auto-refresh
              </tspan>
            </text>

            <text
              fill="#B3B3B3"
              style={{ whiteSpace: 'pre' }}
              fontSize="13"
              letterSpacing="0em"
            >
              {isAutoRefreshEnabled ? (
                <>
                  <tspan x="16" y="509.257">
                    This playlist will automatically refresh with new songs. The{' '}
                  </tspan>
                  <tspan x="16" y="525.257">
                    songs you add will always stay.
                  </tspan>
                </>
              ) : (
                <tspan x="16" y="509.257">
                  This playlist won’t automatically refresh with new songs.
                </tspan>
              )}
            </text>
            <path
              stroke="#535353"
              strokeLinecap="square"
              d="M42 364.493l294-.494"
            ></path>
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="10"
              fontWeight="bold"
              letterSpacing=".1em"
            >
              <tspan x="141.324" y="205.275">
                ADD COVER ART
              </tspan>
            </text>
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="10"
              fontWeight="bold"
              letterSpacing=".1em"
            >
              <tspan x="135.287" y="405.275">
                ADD DESCRIPTION
              </tspan>
            </text>
            <path
              fill="#535353"
              d="M125 389h126v-2H125v2zm126 26H125v2h126v-2zm-126 0c-7.18 0-13-5.82-13-13h-2c0 8.284 6.716 15 15 15v-2zm139-13c0 7.18-5.82 13-13 13v2c8.284 0 15-6.716 15-15h-2zm-13-13c7.18 0 13 5.82 13 13h2c0-8.284-6.716-15-15-15v2zm-126-2c-8.284 0-15 6.716-15 15h2c0-7.18 5.82-13 13-13v-2z"
            ></path>
          </g>

          <foreignObject width="300" height="50" x="40" y="316">
            <input
              type="text"
              value={name}
              placeholder="Playlist name"
              className="CreateNewPlaylist__input-name"
              onChange={(event) => setName(event?.target?.value)}
            />
          </foreignObject>

          <defs>
            <clipPath id="create-new-playlist-clip0">
              <path fill="#fff" d="M0 0H375V812H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </form>
    </div>
  );
});
